import { Observable, filter, map, Subject } from "rxjs";
import {
  InChannelMessage,
  InChannelJoin,
  InChannelLeave,
  ErrorMessage,
  InChannelBroadcast,
  OutChannelBroadcast,
} from "./message";

export class Channel {
  constructor(
    public readonly name: string,
    private readonly appId: string,
    private readonly inStream: Observable<
      InChannelMessage<unknown> | InChannelJoin | InChannelLeave | ErrorMessage | InChannelBroadcast
    >,
    private readonly outStream: Subject<OutChannelBroadcast<unknown>>,
    private readonly leaveCallback: () => void,
  ) {}

  private left = false;

  public readonly messages$ = <T>(
    ...eventName: string[]
  ): Observable<{ payload: T; event: string } | null> => {
    return this.inStream.pipe(
      filter((e): e is InChannelMessage<T> =>
        e.action === "message" && eventName ? eventName.includes(e.data.event) : true,
      ),
      map((e) => ({ payload: e.data.payload, event: e.data.event })),
    );
  };

  public joined$ = (): Observable<boolean> => {
    return this.inStream.pipe(
      filter((m) => m.action === "join" || m.action === "leave"),
      map((m) => m.action === "join"),
    );
  };

  public post = <T>(eventName: string, payload: T) => {
    this.outStream.next({
      service: "channel",
      action: "broadcast",
      appId: this.appId,
      data: {
        channel: this.name,
        event: eventName,
        payload: payload,
      },
    });
  };

  public leave = () => {
    if (this.left) return;
    this.left = true;
    this.leaveCallback();
  };
}
